import { BaseService } from "../BaseService";
import { httpClient } from "../HttpClient";
import { IProductService } from "../interfaces/IProductService";
import { IProduct } from "../interfaces/IProduct";
import SessionCountsRequest from "../request_objects/charts/SessionCountsRequest";
import { AxiosRequestConfig } from "axios";

export class ProductService implements BaseService, IProductService {
  public END_POINT: string = "products";
  public CHARTS_END_POINT: string = "charts";
  public VERSION: string = process.env.VUE_APP_API_VERSION;

  public async getProducts(config?: AxiosRequestConfig): Promise<IProduct> {
    return await httpClient.get(
      `${this.END_POINT}/${this.VERSION}/products`,
      config
    );
  }

    public async getTools(config?: AxiosRequestConfig): Promise<ITool> {
    return await httpClient.get(
      `${this.END_POINT}/${this.VERSION}/tools/public?count=1000&skip=0`,
      config
    );
  }

  public async getProductLatestVersionwithTools(
    productId: string
  ): Promise<IProduct> {
    return await httpClient.get(
      `${this.END_POINT}/${this.VERSION}/productversions/latest/${productId}`
    );
  }

  public async getAppSessionsDataByProduct(
    organizationId: string,
    productId: string,
    days: number
  ) {
    return await httpClient.get(
      `${this.CHARTS_END_POINT}/${this.VERSION}/csl/app-session-data-by-tool?organizationId=${organizationId}&productId=${productId}&days=${days}`
  )};

  public async getProductToolsSessionsCount(
    productId: string,
    timeFrame: number
  ): Promise<IProduct> {
    return await httpClient.get(
      `${this.CHARTS_END_POINT}/${this.VERSION}/csl/product-tools-user-session-count?productId=${productId}&timeFrame=${timeFrame}`
    );
  }

  public async getSelectedOrgProducts(organizationId: string): Promise<IProduct> {
    return await httpClient.get(
      `${this.CHARTS_END_POINT}/${this.VERSION}/csl/license-counts?orgId=${organizationId}`
    );
  }
  
    public async getSessionCounts(
    days: number,
    request: SessionCountsRequest
  ) {
    return await httpClient.post(
      `${this.CHARTS_END_POINT}/${this.VERSION}/csl/session-counts?&days=${days}`,
    );
  }

  public async getDistinctUserCounts(
    days: number,
    request: SessionCountsRequest
  ) {
    return await httpClient.post(
      `${this.CHARTS_END_POINT}/${this.VERSION}/csl/unique-user-counts?&days=${days}`,
    );
  }


  public async getConcurrencyLicenseUsageChartData(
    organizationId: string,
    productIds: []
  ) {
    return await httpClient.post(
      `${this.CHARTS_END_POINT}/${this.VERSION}/csl/concurrent-license-usage-data?organizationId=${organizationId}`,
      productIds
    );
  }
}
